// 导出的流Blob,filename 导出的文件名
export function downloadFileBlob(data: Blob, filename: string) {
  if (!data) {
    return
  }
  console.log(data)
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', filename)

  document.body.appendChild(link)
  link.click()
}

type findTargetValueByKeyParamsType = (
  key: string, // 目标值
  originArr: any[], // 目标数组
  comparativeField: string, // 目标字段
  childrenField: string, // 子节点数组名称
  handleFunc?: (item: any) => void // 加工函数
) => any

// 根据关键值检索目标值
export const findTargetValueByKey: findTargetValueByKeyParamsType = (
  key,
  originArr,
  comparativeField,
  childrenField,
  handleFunc
) => {
  for (const item of originArr) {
    // console.log(item[comparativeField], key)
    handleFunc && handleFunc(item[comparativeField]) // 特殊处理
    if (item[comparativeField] === key) {
      return item
    } else {
      if (item[childrenField] && item[childrenField].length) {
        const result = findTargetValueByKey(
          key,
          item[childrenField],
          comparativeField,
          childrenField,
          handleFunc
        )
        if (result) return result
      }
    }
  }
}

/**
 * 评审意见状态
 * @param state
 */
export function getOpinionState(state: number) {
  switch (state) {
    case 1:
      return '未提交'
    case 2:
      return '新建'
    case 3:
      return 'Accept接受'
    case 4:
      return 'Discuss讨论'
    case 5:
      return '已修改'
    case 6:
      return '关闭'
    case 7:
      return '重启'
    case 8:
      return '待修改'
    case 9:
      return '评审遗留'
    case 10:
      return 'Reject拒绝'
    case 11:
      return 'Duplicate重复'
    default:
      return ''
  }
}

/**
 * 评审意见等级
 * @param grade
 */
export function getOpinionGrade(grade: string) {
  switch (grade) {
    case '1':
      return 'Suggest提示'
    case '2':
      return 'General一般'
    case '3':
      return 'Major严重'
    default:
      return ''
  }
}

/**
 * 评审状态
 * @param state
 */
export function getReviewState(state: number) {
  switch (state) {
    case 2:
      return '进行中'
    case 3:
      return '已关闭'
    case 4:
      return '到期自动关闭'
    default:
      return ''
  }
}

/**
 * 文档 产品状态
 * @param state
 */
export function getDocAndProState(state: number) {
  switch (state) {
    case -1:
      return '已取消'
    case 0:
      return '初稿'
    case 1:
      return '正在工作'
    case 2:
      return '审阅中'
    case 3:
      return '返回修改'
    case 4:
      return '申请中'
    case 9:
      return '已发布'
    case 10:
      return '禁用'
    case 11:
      return '废弃'
    case 12:
      return '设计'
    case 13:
      return '预发布'
    case 14:
      return '认证中'
    case 15:
      return '已认证'
    case 16:
      return '已批准'
    case 17:
      return '工程发布'
    default:
      return '暂无'
  }
}

/**
 * 处理目录数据
 * @param folder
 * @returns {*|[]}
 */
export function dealFolderEcho(folder: any) {
  let newArr = []
  newArr = folder.map((item: any) => ({
    ...item,
    disabled: true,
    folderName: item.storageName,
    children: item.projectFolders
  }))
  return newArr
}

/**
 * 数组去重
 * @param arr
 * @returns {[]}
 */
export function deDuplication(arr: any) {
  const cache: any = []
  for (const t of arr) {
    if (cache.find((c: any) => c.id === t.id)) {
      continue
    }
    cache.push(t)
  }
  return cache
}

// 判空方法
export function isNotEmpty(obj: any) {
  return obj !== undefined && obj !== null && obj !== '' && obj !== 'null'
}

// 获取文件后缀名
export function getFileSuffix(fileName: string) {
  return fileName.substring(fileName.lastIndexOf('.') + 1)
}
